var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7971_152820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8792 6.36829L13.1033 4.35499C13.59 3.91434 14.1589 3.57389 14.7772 3.35307C15.3956 3.13225 16.0514 3.03538 16.7072 3.06801C17.363 3.10063 18.0059 3.26211 18.5993 3.54321C19.1927 3.82432 19.7249 4.21955 20.1656 4.70634C20.6062 5.19313 20.9467 5.76194 21.1675 6.38031C21.3883 6.99867 21.4852 7.65447 21.4526 8.31027C21.4199 8.96607 21.2585 9.60902 20.9774 10.2024C20.6963 10.7958 20.301 11.328 19.8142 11.7687L17.5901 13.782M13.1419 17.8086L10.9178 19.8219C10.431 20.2625 9.86222 20.603 9.24386 20.8238C8.6255 21.0446 7.96969 21.1415 7.31389 21.1088C5.98945 21.043 4.74543 20.4536 3.85549 19.4705C2.96556 18.4874 2.50262 17.191 2.56851 15.8666C2.6344 14.5421 3.22372 13.2981 4.20684 12.4082L6.43094 10.3949",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04492 14.7734L14.9759 9.40465",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7971_152820"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.c1c32ed2434cba1bc3bd43988fc0a5bf.svg";
export { ForwardRef as ReactComponent };